import React, { Component } from "react";
import "./Our-Story.css";
import Container from "../../components/Container";
import Sidebar from "../../components/Sidebar";
import heroImage from "../../img/our-story.jpg";

class OurStory extends Component {
    render() {
        return (
            <Container backgroundColor="#ffffff">
                <div className="page-sidebar our-story">
                    <div>
                        <h1>Our Story</h1>
                        <div className="our-story-layout">
                            <div className="our-story-hero">
                                <img src={heroImage} alt="Inroads to Recovery" />
                            </div>
                            <div className="our-story-text">
                                <p>Inroads to Recovery began its operations in 2004 with just one patient in a small room, driven by the profound belief that every person deserves hope, dignity, and a team of professionals who truly understand their pain. From those modest beginnings, we have grown into a 10,000 square foot healing space that now supports thousands of individuals on their journey to recovery and emotional well-being&mdash;yet our purpose and our heart remain unchanged.</p>
                                <p>As Nebraska&rsquo;s only family-owned and minority-owned, privately held mental health and substance use treatment facility, our work is deeply personal; we are a family caring for families. Guided by compassionate leaders such as President Dr. Syed Pirzada Sattar and Chief Operating Officer Fatima Basith, whose commitment extends far beyond our walls and into the greater Omaha community, we strive to offer a place where every person feels safe, valued, and supported.</p>
                                <p>Our family-oriented culture and flexible, accessible programs&mdash;from residential to outpatient to intensive outpatient&mdash;allow us to meet people exactly where they are, with warmth and respect. We stand committed to breaking the stigma surrounding mental health and addiction, echoing Nebraska&rsquo;s broader mission to expand awareness and bring healing within reach for all.</p>
                                <p>Above all, every individual who walks through our doors is welcomed with empathy, evidence-based care, and a homelike environment that reminds them they are not alone&mdash;and that their healing journey is both possible and worth fighting for. In everything we do, we strive to <strong>Include, Improve, and Inspire</strong>.</p>
                            </div>
                        </div>
                    </div>
                    <Sidebar />
                </div>
            </Container>
        );
    }
}

export default OurStory;
